/* tslint:disable */
/* eslint-disable */
/**
* This file is auto-generated by the API parser
* Please note that any changes in this file may be overwritten
* Version: 2025-07-31 17:42:53
/*



/**
@description
Type of Asset for all PAKs.
*/
var EAssetType = /*#__PURE__*/function (EAssetType) {
  EAssetType["none"] = "none";
  EAssetType["product"] = "product";
  EAssetType["material"] = "material";
  EAssetType["environment"] = "environment";
  EAssetType["level"] = "level";
  EAssetType["camera"] = "camera";
  EAssetType["showcase"] = "showcase";
  EAssetType["screenshot"] = "screenshot";
  EAssetType["light"] = "light";
  return EAssetType;
}(EAssetType || {});
/**
@description
Dimension type.
*/
var EDimensionType = /*#__PURE__*/function (EDimensionType) {
  EDimensionType["none"] = "none";
  EDimensionType["millimeter"] = "millimeter";
  EDimensionType["centimeter"] = "centimeter";
  EDimensionType["meter"] = "meter";
  EDimensionType["kilometer"] = "kilometer";
  EDimensionType["inch"] = "inch";
  EDimensionType["foot"] = "foot";
  EDimensionType["yard"] = "yard";
  EDimensionType["mile"] = "mile";
  return EDimensionType;
}(EDimensionType || {});
/**
@description
SequenceLoopBehavior.
*/
var ESequenceLoopBehavior = /*#__PURE__*/function (ESequenceLoopBehavior) {
  ESequenceLoopBehavior["none"] = "none";
  ESequenceLoopBehavior["loop"] = "loop";
  ESequenceLoopBehavior["pingPong"] = "pingPong";
  ESequenceLoopBehavior["loopSection"] = "loopSection";
  ESequenceLoopBehavior["pingPongSection"] = "pingPongSection";
  return ESequenceLoopBehavior;
}(ESequenceLoopBehavior || {});
/**
@description
Measure axis position.
*/
var EBoolState = /*#__PURE__*/function (EBoolState) {
  EBoolState["none"] = "none";
  EBoolState["trueState"] = "trueState";
  EBoolState["falseState"] = "falseState";
  return EBoolState;
}(EBoolState || {});
/**
@description
Items types that can be placed in scene.
*/
var ESceneItemType = /*#__PURE__*/function (ESceneItemType) {
  ESceneItemType["products"] = "products";
  ESceneItemType["lights"] = "lights";
  ESceneItemType["pawn"] = "pawn";
  return ESceneItemType;
}(ESceneItemType || {});
/**
@deprecated
Use {@link EDimensionLineZPlacement}

All deprecated properties marked as optional. Use with care!

@description
Placement of Z dimension line.
*/
var EMeasureAxisZPosition = /*#__PURE__*/function (EMeasureAxisZPosition) {
  EMeasureAxisZPosition["front"] = "front";
  EMeasureAxisZPosition["left"] = "left";
  EMeasureAxisZPosition["right"] = "right";
  EMeasureAxisZPosition["leftRight"] = "leftRight";
  EMeasureAxisZPosition["back"] = "back";
  return EMeasureAxisZPosition;
}(EMeasureAxisZPosition || {});
/**
@description
Placement of vertical (Z axis) line based on camera view. Near or front, left, right, far or back side of the bounding box
*/
var EVerticalLinePlacement = /*#__PURE__*/function (EVerticalLinePlacement) {
  EVerticalLinePlacement["near"] = "near";
  EVerticalLinePlacement["left"] = "left";
  EVerticalLinePlacement["right"] = "right";
  EVerticalLinePlacement["leftRightBasedOnCamera"] = "leftRightBasedOnCamera";
  EVerticalLinePlacement["far"] = "far";
  return EVerticalLinePlacement;
}(EVerticalLinePlacement || {});
/**
@description
Placement of horizontal (X, Y axis) lines along top, bottom, top-bottom face of the bounding box
*/
var EHorizontalLinePlacement = /*#__PURE__*/function (EHorizontalLinePlacement) {
  EHorizontalLinePlacement["top"] = "top";
  EHorizontalLinePlacement["bottom"] = "bottom";
  EHorizontalLinePlacement["topBottomBasedOnCamera"] = "topBottomBasedOnCamera";
  return EHorizontalLinePlacement;
}(EHorizontalLinePlacement || {});
/**
@description
Dimension line appearance.
*/
var EDimensionLine = /*#__PURE__*/function (EDimensionLine) {
  EDimensionLine["solid"] = "solid";
  EDimensionLine["dashed"] = "dashed";
  return EDimensionLine;
}(EDimensionLine || {});
/**
@description
Dimension line end appearance.
*/
var EDimensionLineTerminator = /*#__PURE__*/function (EDimensionLineTerminator) {
  EDimensionLineTerminator["none"] = "none";
  EDimensionLineTerminator["cube"] = "cube";
  EDimensionLineTerminator["sphere"] = "sphere";
  EDimensionLineTerminator["tickMark"] = "tickMark";
  EDimensionLineTerminator["arrowHead"] = "arrowHead";
  return EDimensionLineTerminator;
}(EDimensionLineTerminator || {});
/**
@description
Measure axis position.
*/
var EMeasurementRenderMode = /*#__PURE__*/function (EMeasurementRenderMode) {
  EMeasurementRenderMode["lit"] = "lit";
  EMeasurementRenderMode["emissive"] = "emissive";
  EMeasurementRenderMode["overlay"] = "overlay";
  return EMeasurementRenderMode;
}(EMeasurementRenderMode || {});
/**
@description
Measure axis position.
*/
var EPaddingUnit = /*#__PURE__*/function (EPaddingUnit) {
  EPaddingUnit["pixel"] = "pixel";
  EPaddingUnit["cm"] = "cm";
  return EPaddingUnit;
}(EPaddingUnit || {});
/**
@description
Curve type.
*/
var ECurve = /*#__PURE__*/function (ECurve) {
  ECurve["linear"] = "linear";
  ECurve["inSine"] = "inSine";
  ECurve["outSine"] = "outSine";
  ECurve["inOutSine"] = "inOutSine";
  ECurve["inQuad"] = "inQuad";
  ECurve["outQuad"] = "outQuad";
  ECurve["inOutQuad"] = "inOutQuad";
  ECurve["inCubic"] = "inCubic";
  ECurve["outCubic"] = "outCubic";
  ECurve["inOutCubic"] = "inOutCubic";
  ECurve["inQuart"] = "inQuart";
  ECurve["outQuart"] = "outQuart";
  ECurve["inOutQuart"] = "inOutQuart";
  ECurve["inQuint"] = "inQuint";
  ECurve["outQuint"] = "outQuint";
  ECurve["inOutQuint"] = "inOutQuint";
  ECurve["inExpo"] = "inExpo";
  ECurve["outExpo"] = "outExpo";
  ECurve["inOutExpo"] = "inOutExpo";
  ECurve["inCirc"] = "inCirc";
  ECurve["outCirc"] = "outCirc";
  ECurve["inOutCirc"] = "inOutCirc";
  ECurve["inBack"] = "inBack";
  ECurve["outBack"] = "outBack";
  ECurve["inOutBack"] = "inOutBack";
  ECurve["inElastic"] = "inElastic";
  ECurve["outElastic"] = "outElastic";
  ECurve["inOutElastic"] = "inOutElastic";
  ECurve["inBounce"] = "inBounce";
  ECurve["outBounce"] = "outBounce";
  ECurve["inOutBounce"] = "inOutBounce";
  return ECurve;
}(ECurve || {});
/**
@description
Fit options.
*/
var EFitMethod = /*#__PURE__*/function (EFitMethod) {
  EFitMethod["none"] = "none";
  EFitMethod["byLocation"] = "byLocation";
  EFitMethod["byRotation"] = "byRotation";
  EFitMethod["top"] = "top";
  EFitMethod["bottom"] = "bottom";
  EFitMethod["front"] = "front";
  EFitMethod["back"] = "back";
  EFitMethod["right"] = "right";
  EFitMethod["left"] = "left";
  return EFitMethod;
}(EFitMethod || {});
/**
@description
Movement allowance along specified axis.
*/
var EMovementAllowance = /*#__PURE__*/function (EMovementAllowance) {
  EMovementAllowance["none"] = "none";
  EMovementAllowance["planeYZ"] = "planeYZ";
  EMovementAllowance["planeXY"] = "planeXY";
  EMovementAllowance["planeXZ"] = "planeXZ";
  EMovementAllowance["axisX"] = "axisX";
  EMovementAllowance["axisY"] = "axisY";
  EMovementAllowance["axisZ"] = "axisZ";
  return EMovementAllowance;
}(EMovementAllowance || {});
/**
@description
Alignment options.
*/
var EAlignment = /*#__PURE__*/function (EAlignment) {
  EAlignment["byBottomSide"] = "byBottomSide";
  EAlignment["byTopSide"] = "byTopSide";
  EAlignment["byFrontSide"] = "byFrontSide";
  EAlignment["byBackSide"] = "byBackSide";
  EAlignment["byRightSide"] = "byRightSide";
  EAlignment["byLeftSide"] = "byLeftSide";
  return EAlignment;
}(EAlignment || {});
/**
@description
Gizmo type.
*/
var EGizmoType = /*#__PURE__*/function (EGizmoType) {
  EGizmoType["translation"] = "translation";
  EGizmoType["rotation"] = "rotation";
  EGizmoType["scale"] = "scale";
  EGizmoType["none"] = "none";
  return EGizmoType;
}(EGizmoType || {});
/**
@description
Pawn camera control mode.
*/
var EControlMode = /*#__PURE__*/function (EControlMode) {
  EControlMode["none"] = "none";
  EControlMode["select"] = "select";
  EControlMode["orbit"] = "orbit";
  EControlMode["pan"] = "pan";
  EControlMode["dolly"] = "dolly";
  return EControlMode;
}(EControlMode || {});
/**
@description
Pawn movement mode.
*/
var EPawnMovementMode = /*#__PURE__*/function (EPawnMovementMode) {
  EPawnMovementMode["none"] = "none";
  EPawnMovementMode["around"] = "around";
  EPawnMovementMode["aroundBlocking"] = "aroundBlocking";
  EPawnMovementMode["walk"] = "walk";
  EPawnMovementMode["aroundObstacles"] = "aroundObstacles";
  EPawnMovementMode["productsControl"] = "productsControl";
  return EPawnMovementMode;
}(EPawnMovementMode || {});
/**
@description
Light mode.
*/
var ELightMode = /*#__PURE__*/function (ELightMode) {
  ELightMode["NONE"] = "NONE";
  ELightMode["RECT"] = "RECT";
  ELightMode["PANEL"] = "PANEL";
  return ELightMode;
}(ELightMode || {});
/**
@description
Rectangle light type.
*/
var ERectLightType = /*#__PURE__*/function (ERectLightType) {
  ERectLightType["rect"] = "rect";
  ERectLightType["circ"] = "circ";
  ERectLightType["hexa"] = "hexa";
  return ERectLightType;
}(ERectLightType || {});
/**
@deprecated
Don't need anymore.

All deprecated properties marked as optional. Use with care!

@description
App type.
*/
var EAppType = /*#__PURE__*/function (EAppType) {
  EAppType["none"] = "none";
  EAppType["platform"] = "platform";
  EAppType["metabox"] = "metabox";
  EAppType["vps"] = "vps";
  EAppType["abg"] = "abg";
  EAppType["htmx"] = "htmx";
  EAppType["proampac"] = "proampac";
  return EAppType;
}(EAppType || {});
/**
@description
DLSS mode.
*/
var EDlssMode = /*#__PURE__*/function (EDlssMode) {
  EDlssMode["Off"] = "Off";
  EDlssMode["Auto"] = "Auto";
  EDlssMode["DLAA"] = "DLAA";
  EDlssMode["UltraQuality"] = "UltraQuality";
  EDlssMode["Quality"] = "Quality";
  EDlssMode["Balanced"] = "Balanced";
  EDlssMode["Performance"] = "Performance";
  return EDlssMode;
}(EDlssMode || {});
var MetaBoxCommand = /*#__PURE__*/function (MetaBoxCommand) {
  /**
  @deprecated
  No need
  */
  MetaBoxCommand["FLoadPaksInMemoryCommand"] = "loadPaksInMemory";
  MetaBoxCommand["FSetDlssModeCommand"] = "setDlssMode";
  MetaBoxCommand["FLoadProductCommand"] = "loadProduct";
  /**
  @deprecated
  Use {@link FLoadProductCommand}
  */
  MetaBoxCommand["FSelectProductCommand"] = "selectProduct";
  MetaBoxCommand["FUnLoadProductByObjectNameCommand"] = "unLoadProductByObjectName";
  /**
  @deprecated
  Use {@link FUnLoadProductByObjectNameCommand}
  */
  MetaBoxCommand["FRemoveProductInSceneCommand"] = "removeProductInScene";
  MetaBoxCommand["FUnLoadAllProductsCommand"] = "unLoadAllProducts";
  /**
  @deprecated
  Use {@link FUnLoadAllProductsCommand}
  */
  MetaBoxCommand["FRemoveAllProductsCommand"] = "removeAllProducts";
  MetaBoxCommand["FSetFlyingMeshCommand"] = "setFlyingMesh";
  MetaBoxCommand["FLoadLevelCommand"] = "loadLevel";
  MetaBoxCommand["FUnLoadLevelCommand"] = "unLoadLevel";
  /**
  @deprecated
  Use {@link FUnLoadLevelCommand}
  */
  MetaBoxCommand["FHideLevelCommand"] = "hideLevel";
  MetaBoxCommand["FUnLoadAllLevelsCommand"] = "unLoadAllLevels";
  /**
  @deprecated
  Use {@link FUnLoadAllLevelsCommand}
  */
  MetaBoxCommand["FHideAllLevelsCommand"] = "hideAllLevels";
  MetaBoxCommand["FSetMaterialCommand"] = "setMaterial";
  MetaBoxCommand["FSetFlyingMaterialCommand"] = "setFlyingMaterial";
  MetaBoxCommand["FPlayAnimationCommand"] = "playAnimation";
  MetaBoxCommand["FLoadButtonCommand"] = "loadButton";
  MetaBoxCommand["FUnLoadButtonByObjectNameCommand"] = "unLoadButtonByObjectName";
  MetaBoxCommand["FUnLoadAllButtonsCommand"] = "unLoadAllButtons";
  MetaBoxCommand["FSetButtonScaleCommand"] = "setButtonScale";
  MetaBoxCommand["FRequestUnwrapImageCommand"] = "requestUnwrapImage";
  /**
  @deprecated
  Use {@link FShowMeasurementCommand}
  */
  MetaBoxCommand["FLoadMeasureCommand"] = "loadMeasure";
  MetaBoxCommand["FShowMeasurementCommand"] = "showMeasurement";
  MetaBoxCommand["FUnLoadMeasureByObjectNameCommand"] = "unLoadMeasureByObjectName";
  MetaBoxCommand["FHideMeasurementByObjectNameCommand"] = "hideMeasurementByObjectName";
  MetaBoxCommand["FUnLoadAllMeasuresCommand"] = "unLoadAllMeasures";
  MetaBoxCommand["FGetAssetsInPakCommand"] = "getAssetsInPak";
  MetaBoxCommand["FChangeGizmoTypeCommand"] = "changeGizmoType";
  MetaBoxCommand["FSetSelectionSettingsCommand"] = "setSelectionSettings";
  MetaBoxCommand["FDragCommand"] = "drag";
  MetaBoxCommand["FDropCommand"] = "drop";
  /**
  @deprecated
  Use {@link FFitToObjectsCommand}
  */
  MetaBoxCommand["FFitCommand"] = "fit";
  MetaBoxCommand["FFitToObjectsCommand"] = "fitToObjects";
  MetaBoxCommand["FFitToObjectsByBSphereCommand"] = "fitToObjectsByBSphere";
  MetaBoxCommand["FFitToObjectsByBBoxCommand"] = "fitToObjectsByBBox";
  MetaBoxCommand["FLookAtLocationCommand"] = "lookAtLocation";
  MetaBoxCommand["FLookAtObjectsCommand"] = "lookAtObjects";
  /**
  @deprecated
  Use {@link FSelectProductByObjectNameCommand}
  */
  MetaBoxCommand["FSelectProductInSceneCommand"] = "selectProductInScene";
  MetaBoxCommand["FSelectProductByObjectNameCommand"] = "selectProductByObjectName";
  MetaBoxCommand["FUnselectAllProductsCommand"] = "unselectAllProducts";
  MetaBoxCommand["FMoveSelectedCommand"] = "moveSelected";
  MetaBoxCommand["FMoveProductByObjectNameCommand"] = "moveProductByObjectName";
  MetaBoxCommand["FSetProductsLocationCommand"] = "setProductsLocation";
  MetaBoxCommand["FAlignProductsToPlaneCommand"] = "alignProductsToPlane";
  MetaBoxCommand["FRotateSelectedCommand"] = "rotateSelected";
  MetaBoxCommand["FRotateObjectNameCommand"] = "rotateObjectName";
  MetaBoxCommand["FRotateActorByTagCommand"] = "rotateActorByTag";
  /**
  @deprecated
  Use {@link FUnloadSelectedProductCommand}
  */
  MetaBoxCommand["FRemoveFocusedCommand"] = "removeFocused";
  MetaBoxCommand["FUnloadSelectedProductCommand"] = "unloadSelectedProduct";
  MetaBoxCommand["FAttachActorCommand"] = "attachActor";
  MetaBoxCommand["FDetachActorCommand"] = "detachActor";
  MetaBoxCommand["FDetachAllActorsCommand"] = "detachAllActors";
  MetaBoxCommand["FMoveAttachedActorsInSocketCommand"] = "moveAttachedActorsInSocket";
  MetaBoxCommand["FEnableTeleportCommand"] = "enableTeleport";
  MetaBoxCommand["FSetPawnMovementModeCommand"] = "setPawnMovementMode";
  MetaBoxCommand["FSnapAxisCommand"] = "snapAxis";
  MetaBoxCommand["FClickSnapCommand"] = "clickSnap";
  MetaBoxCommand["FPawnTransformControlCommand"] = "pawnTransformControl";
  MetaBoxCommand["FFlyingProductCommand"] = "flyingProduct";
  MetaBoxCommand["FFreezeFrameCommand"] = "freezeFrame";
  MetaBoxCommand["FFreezeFrameV2Command"] = "freezeFrameV2";
  MetaBoxCommand["FUnfreezeFrameV2Command"] = "unfreezeFrameV2";
  /**
  @deprecated
  Use {@link FControlSensitivityCommand}
  */
  MetaBoxCommand["FMouseSensitivityCommand"] = "mouseSensitivity";
  MetaBoxCommand["FControlSensitivityCommand"] = "controlSensitivity";
  MetaBoxCommand["FEnableComposureCommand"] = "enableComposure";
  MetaBoxCommand["FEnableCursorCommand"] = "enableCursor";
  MetaBoxCommand["FEnableControlsCommand"] = "enableControls";
  MetaBoxCommand["FEnableSelectionByCursorCommand"] = "enableSelectionByCursor";
  MetaBoxCommand["FEnableRotationByCursorCommand"] = "enableRotationByCursor";
  MetaBoxCommand["FEnableZoomByCursorCommand"] = "enableZoomByCursor";
  MetaBoxCommand["FEnableInteractByCursorCommand"] = "enableInteractByCursor";
  MetaBoxCommand["FEnablePanByCursorCommand"] = "enablePanByCursor";
  MetaBoxCommand["FEnableControlsByCursorCommand"] = "enableControlsByCursor";
  MetaBoxCommand["FSetControlCameraModeCommand"] = "setControlCameraMode";
  MetaBoxCommand["FSetCameraHeightCommand"] = "setCameraHeight";
  MetaBoxCommand["FAddCameraHeightCommand"] = "addCameraHeight";
  /**
  @deprecated
  Use {@link FAddCameraHeightCommand}
  */
  MetaBoxCommand["FMoveCameraCommand"] = "moveCamera";
  MetaBoxCommand["FCameraBoxCommand"] = "cameraBox";
  /**
  @deprecated
  Use {@link FClampPanToProductsCommand}
  */
  MetaBoxCommand["FClampPanToProductCommand"] = "clampPanToProduct";
  MetaBoxCommand["FClampPanToProductsCommand"] = "clampPanToProducts";
  MetaBoxCommand["FSetCameraControlClampsCommand"] = "setCameraControlClamps";
  MetaBoxCommand["FResetControlClampsCommand"] = "resetControlClamps";
  MetaBoxCommand["FCameraSettingsCommand"] = "cameraSettings";
  /**
  @deprecated
  Use {@link FCameraSettingsCommand}
  */
  MetaBoxCommand["FChangeFovCommand"] = "changeFov";
  MetaBoxCommand["FApplyCameraPresetCommand"] = "applyCameraPreset";
  MetaBoxCommand["FSetCameraTransformCommand"] = "setCameraTransform";
  MetaBoxCommand["FRequestCameraPresetCommand"] = "requestCameraPreset";
  MetaBoxCommand["FCameraRecenterCommand"] = "cameraRecenter";
  /**
  @deprecated
  Description does not match implementation
  */
  MetaBoxCommand["FResetZoomCommand"] = "resetZoom";
  /**
  @deprecated
  Use {@link FResetZoomCommand}
  */
  MetaBoxCommand["FResetMinZoomCommand"] = "resetMinZoom";
  MetaBoxCommand["FApplyZoomCommand"] = "applyZoom";
  /**
  @deprecated
  Use {@link FApplyZoomCommand}
  */
  MetaBoxCommand["FZoomCommand"] = "zoom";
  MetaBoxCommand["FAddPanelLightCommand"] = "addPanelLight";
  MetaBoxCommand["FUpdatePanelLightCommand"] = "updatePanelLight";
  MetaBoxCommand["FAddRectLightCommand"] = "addRectLight";
  MetaBoxCommand["FUpdateRectLightCommand"] = "updateRectLight";
  MetaBoxCommand["FRemoveLightCommand"] = "removeLight";
  MetaBoxCommand["FSetHdrCommand"] = "setHdr";
  MetaBoxCommand["FWeatherCommand"] = "weather";
  /**
  @deprecated
  Use {@link FWeatherCommand}
  */
  MetaBoxCommand["FEnableUDSCommand"] = "enableUDS";
  /**
  @deprecated
  Use {@link FWeatherCommand}
  */
  MetaBoxCommand["FTimeUDSCommand"] = "timeUDS";
  /**
  @deprecated
  Use {@link FWeatherCommand}
  */
  MetaBoxCommand["FSetSunOrientationCommand"] = "setSunOrientation";
  MetaBoxCommand["FEnableLightModeCommand"] = "enableLightMode";
  MetaBoxCommand["FSetSettingsSequenceCommand"] = "setSettingsSequence";
  MetaBoxCommand["FInitSequenceCommand"] = "initSequence";
  MetaBoxCommand["FInitSequenceByObjectNameCommand"] = "initSequenceByObjectName";
  MetaBoxCommand["FPlaySequenceCommand"] = "playSequence";
  MetaBoxCommand["FJumpToSequenceCommand"] = "jumpToSequence";
  MetaBoxCommand["FDragSequenceCommand"] = "dragSequence";
  MetaBoxCommand["FPauseSequenceCommand"] = "pauseSequence";
  MetaBoxCommand["FStopSequenceCommand"] = "stopSequence";
  /**
  @deprecated
  Use {@link FPlaySequenceCommand}
  */
  MetaBoxCommand["FResumeSequenceCommand"] = "resumeSequence";
  /**
  @deprecated
  Use {@link FInitSequenceCommand}, {@link FPlaySequenceCommand}
  */
  MetaBoxCommand["FStartSequenceCommand"] = "startSequence";
  /**
  @deprecated
  Use {@link FTakeRenderCommand}
  */
  MetaBoxCommand["FTakeScreenshotCommand"] = "takeScreenshot";
  MetaBoxCommand["FTakeRenderCommand"] = "takeRender";
  /**
  @deprecated
  Use {@link FTakeLayeredRenderCommand}
  */
  MetaBoxCommand["FTakeLayeredScreenshotCommand"] = "takeLayeredScreenshot";
  MetaBoxCommand["FTakeLayeredRenderCommand"] = "takeLayeredRender";
  /**
  @deprecated
  Use {@link FTakeSpinnerRenderCommand}
  */
  MetaBoxCommand["FTake360ScreenshotCommand"] = "take360Screenshot";
  /**
  @deprecated
  Use {@link FTakeSpinnerRenderCommand}
  */
  MetaBoxCommand["FTake360RenderCommand"] = "take360Render";
  MetaBoxCommand["FTakeSpinnerRenderCommand"] = "takeSpinnerRender";
  /**
  @deprecated
  Use {@link FTakeSpinnerRenderPreviewCommand}
  */
  MetaBoxCommand["FTake360PreviewCommand"] = "take360Preview";
  MetaBoxCommand["FTakeSpinnerRenderPreviewCommand"] = "takeSpinnerRenderPreview";
  /**
  @deprecated
  Use {@link FEnableSpinnerModeCommand}
  */
  MetaBoxCommand["F360EnableCommand"] = "360Enable";
  /**
  @deprecated
  Use {@link FEnableSpinnerModeCommand}
  */
  MetaBoxCommand["F360DisableCommand"] = "360Disable";
  MetaBoxCommand["FEnableSpinnerModeCommand"] = "enableSpinnerMode";
  MetaBoxCommand["F360VerticalRotateCommand"] = "360VerticalRotate";
  MetaBoxCommand["FUnDoCommand"] = "unDo";
  MetaBoxCommand["FReDoCommand"] = "reDo";
  MetaBoxCommand["FRequestSceneStateCommand"] = "requestSceneState";
  MetaBoxCommand["FEnableSceneStateCallbackCommand"] = "enableSceneStateCallback";
  /**
  @deprecated
  Use {@link FRequestSceneStateCommand}
  */
  MetaBoxCommand["FSaveSceneStateCommand"] = "saveSceneState";
  MetaBoxCommand["FLoadSceneStateCommand"] = "loadSceneState";
  MetaBoxCommand["FStartUndoRedoChainCommand"] = "startUndoRedoChain";
  MetaBoxCommand["FAddUndoRedoChainCommand"] = "addUndoRedoChain";
  /**
  @deprecated
  Don't need anymore.
  */
  MetaBoxCommand["FAppInitCommand"] = "appInit";
  MetaBoxCommand["FDebugModeCommand"] = "debugMode";
  MetaBoxCommand["FChangeResolutionCommand"] = "changeResolution";
  MetaBoxCommand["FExecuteConsoleCommandCommand"] = "executeConsoleCommand";
  MetaBoxCommand["FPingCommand"] = "ping";
  MetaBoxCommand["FRestartComposeCommand"] = "restartCompose";
  MetaBoxCommand["FResetSceneCommand"] = "resetScene";
  MetaBoxCommand["FDatasmithToPakCommand"] = "datasmithToPak";
  MetaBoxCommand["FMorphToPakCommand"] = "morphToPak";
  MetaBoxCommand["FLoopBackCommand"] = "loopBack";
  MetaBoxCommand["FTestCommand"] = "test";
  return MetaBoxCommand;
}(MetaBoxCommand || {});
/**
* List of deprecated commands.
*/
const DeprecatedCommands = [MetaBoxCommand.FLoadPaksInMemoryCommand, MetaBoxCommand.FSelectProductCommand, MetaBoxCommand.FRemoveProductInSceneCommand, MetaBoxCommand.FRemoveAllProductsCommand, MetaBoxCommand.FHideLevelCommand, MetaBoxCommand.FHideAllLevelsCommand, MetaBoxCommand.FLoadMeasureCommand, MetaBoxCommand.FFitCommand, MetaBoxCommand.FSelectProductInSceneCommand, MetaBoxCommand.FRemoveFocusedCommand, MetaBoxCommand.FMouseSensitivityCommand, MetaBoxCommand.FMoveCameraCommand, MetaBoxCommand.FClampPanToProductCommand, MetaBoxCommand.FChangeFovCommand, MetaBoxCommand.FResetZoomCommand, MetaBoxCommand.FResetMinZoomCommand, MetaBoxCommand.FZoomCommand, MetaBoxCommand.FEnableUDSCommand, MetaBoxCommand.FTimeUDSCommand, MetaBoxCommand.FSetSunOrientationCommand, MetaBoxCommand.FResumeSequenceCommand, MetaBoxCommand.FStartSequenceCommand, MetaBoxCommand.FTakeScreenshotCommand, MetaBoxCommand.FTakeLayeredScreenshotCommand, MetaBoxCommand.FTake360ScreenshotCommand, MetaBoxCommand.FTake360RenderCommand, MetaBoxCommand.FTake360PreviewCommand, MetaBoxCommand.F360EnableCommand, MetaBoxCommand.F360DisableCommand, MetaBoxCommand.FSaveSceneStateCommand, MetaBoxCommand.FAppInitCommand];

/**
 * Generated bundle index. Do not edit.
 */

export { DeprecatedCommands, EAlignment, EAppType, EAssetType, EBoolState, EControlMode, ECurve, EDimensionLine, EDimensionLineTerminator, EDimensionType, EDlssMode, EFitMethod, EGizmoType, EHorizontalLinePlacement, ELightMode, EMeasureAxisZPosition, EMeasurementRenderMode, EMovementAllowance, EPaddingUnit, EPawnMovementMode, ERectLightType, ESceneItemType, ESequenceLoopBehavior, EVerticalLinePlacement, MetaBoxCommand };
